import { Validator } from '@vista-digital/validator';
import { numberConfigValidatorSchema } from './number-config';
/**
 * Checks that a string includes one instance of "%s" and "%v", in any order, with any other characters.
 *
 * (?=.*%s) - contains "%s" with any preceding characters.
 * (?!.*%s.*%s) - only contains one instance of "%s".
 * (?=.*%v) - contains "%v" with any preceding characters.
 * (?!.*%v.*%v) - only contains one instance of "%v".
 */
const currencyFormatStringFormat = new RegExp('^(?=.*%s)(?!.*%s.*%s)(?=.*%v)(?!.*%v.*%v).*$');
export const currencyFormatStringValidator = Validator.string({ format: currencyFormatStringFormat });
const currencyFormatValidator = Validator.object({
    pos: currencyFormatStringValidator,
    neg: Validator.optional(currencyFormatStringValidator),
    zero: Validator.optional(currencyFormatStringValidator)
});
export const currencyConfigValidator = Validator.object(Object.assign(Object.assign({}, numberConfigValidatorSchema), { symbol: Validator.nonEmptyString, format: Validator.any([currencyFormatValidator, currencyFormatStringValidator]) }));
//# sourceMappingURL=currency-config.js.map